import { type FC, useEffect, useRef } from "react";
import { useReadMoreButtonHeight } from "@root/shared/components/ReadMoreButton/useReadMoreButtonHeight";
import { type DeclineDetails } from "@clientFrontend/features/declineReport/components/UserDeclineReport/type";
import * as styles from "./styles.css";

type Props = {
  declineDetails: DeclineDetails;
};

export const DeclineDetailsList: FC<Props> = ({ declineDetails }) => {
  const setContainerHeight = useReadMoreButtonHeight();
  const elementRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (
      elementRefs.current[0] &&
      elementRefs.current[1] &&
      elementRefs.current[2] &&
      setContainerHeight
    ) {
      const totalRefHeight =
        elementRefs.current[0].clientHeight +
        elementRefs.current[1].clientHeight +
        elementRefs.current[2].clientHeight;
      setContainerHeight(totalRefHeight);
    }
  }, [setContainerHeight]);

  return (
    <>
      {declineDetails.map((detail, index) => (
        <div className={styles.box} key={detail.id} ref={(el) => (elementRefs.current[index] = el)}>
          <h3 className={styles.head}>{`理由${index + 1}`}</h3>
          <div className={styles.body}>{detail.description}</div>
        </div>
      ))}
    </>
  );
};
